export default __webpack_public_path__ + "static/media/introEventGaBgMb.74649c4b.png";